import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1039e01a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["src", "alt", "onClick"];
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "对不起，视频不支持播放。", -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "对不起，音频不支持播放。", -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  key: 3,
  style: {
    "font-size": "14px"
  }
};
const _hoisted_12 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_uploader = _resolveComponent("van-uploader");
  const _component_van_image_preview = _resolveComponent("van-image-preview");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.show = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.uploadFileList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "previewImg-wraper",
        style: {
          "margin": "8px"
        }
      }, [$options.isImgUrl(item.uploadFileName) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: $options.getFileUrl(item),
        alt: item.uploadFileName,
        style: {
          "max-width": "100%"
        },
        onClick: $event => $options.onImgClick($options.getFileUrl(item))
      }, null, 8, _hoisted_2), $data.isDelImage ? (_openBlock(), _createBlock(_component_van_icon, {
        key: 0,
        name: "cross",
        onClick: $event => $options.onDelImage(index)
      }, null, 8, ["onClick"])) : _createCommentVNode("", true)])) : $options.isVideoUrl(item.uploadFileName) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("video", {
        controls: "",
        src: $options.getFileUrl(item),
        style: {
          "max-width": "100%"
        }
      }, _hoisted_6, 8, _hoisted_4)])) : $options.isAudioUrl(item.uploadFileName) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("audio", {
        controls: "",
        src: $options.getFileUrl(item),
        style: {
          "max-width": "100%"
        }
      }, _hoisted_10, 8, _hoisted_8)])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("a", {
        href: $options.getFileUrl(item)
      }, _toDisplayString(item.uploadFileName), 9, _hoisted_12)]))]);
    }), 128)), $data.isUpload ? (_openBlock(), _createBlock(_component_van_uploader, {
      key: 0,
      modelValue: $data.uploadFileList,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.uploadFileList = $event),
      "after-read": $options.afterRead,
      "before-delete": $options.onDelImage,
      deletable: true,
      accept: 'image/*',
      "preview-size": 60,
      "upload-text": "请上传图片"
    }, null, 8, ["modelValue", "after-read", "before-delete"])) : _createCommentVNode("", true), _createVNode(_component_van_image_preview, {
      ref: "ImagePreview",
      modelValue: $data.showImgPreview,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.showImgPreview = $event),
      images: $data.preImages
    }, null, 8, ["modelValue", "images"])]),
    _: 1
  }, 8, ["show"]);
}